import React from 'react';
import TextField from '../../../../components/forms/TextField';

interface BlockedCallerNumbersManagerProps {
    value: string;
    onChange: (value: string) => void;
    onBlur: () => void;
    fieldContainerStyle?: string;
}

const BlockedCallerNumbersManager: React.FC<BlockedCallerNumbersManagerProps> = ({
    value,
    onChange,
    onBlur,
    fieldContainerStyle
}) => {
    const handleChange = (e: React.ChangeEvent<any>) => {
        onChange(e.target.value);
    };

    const handleBlur = (e: React.FocusEvent<any>) => {
        const normalized = (e.currentTarget.value ?? '')
            .split(',')
            .map((n: string) => n.trim())
            .filter((n: string) => n.length > 0)
            .join(', ');
        onChange(normalized);
        onBlur();
    };

    return (
        <TextField
            name="blockedCallerNumbers"
            label="Blocked Caller Numbers"
            tooltip="Enter the phone numbers that should be hung up immediately when they call. Separate multiple numbers with commas (e.g. 15551234567, 15559876543)."
            toolTipPosition="right"
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="e.g. 15551234567, 15559876543"
            fieldContainerStyle={fieldContainerStyle}
        />
    );
};

export default BlockedCallerNumbersManager;